export default __webpack_public_path__ + "static/media/hero-img.72afc158.png";